import { Button, Row } from 'antd'
import React from 'react'
import SubHeader from 'utils/subHeader'
import 'containers/routesMaster/App.css'
import { withRouter } from 'react-router'

class DashboardSetting extends React.Component { 
  
    AddDashboard = () => {
        this.props.history.push({
        pathname: '/dashboard-settings/add',
        search: this.props.location.search,
        })
    }
    
    cta = () => {
        return (
        <div>
            <Button style={{ marginLeft: 10 }} size="large" type="primary"
               onClick={this.AddDashboard}
            > Add Dashboard
            </Button>
        </div>
        )
    }

    render() {
        return (
        <Row>
            <SubHeader innerhtml={this.cta} />
              {this.props.children}
        </Row>
        )
    }
}

export default withRouter(DashboardSetting)
